import { render, staticRenderFns } from "./FormCPF.vue?vue&type=template&id=42166921"
import script from "./FormCPF.vue?vue&type=script&lang=js"
export * from "./FormCPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports